var _style, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage5Play(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 98 98",
    style: {
      enableBackground: "new 0 0 98 98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.55;fill:url(#SVGID_00000072268307917728036280000017647194895713559206_);}\r\n\t.st2{opacity:0.55;fill:url(#SVGID_00000163067590685949109610000004442923511421781911_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4217,
    y1: 49,
    x2: 97.5783,
    y2: 49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9982,
    style: {
      stopColor: "#F37C47"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49,
    cy: 49,
    r: 48.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027566742120841696770000017689422805847390624_",
    gradientUnits: "userSpaceOnUse",
    x1: -688.7267,
    y1: 665.7939,
    x2: -611.9257,
    y2: 665.7939,
    gradientTransform: "matrix(-0.4174 -0.4174 -0.7071 0.7071 244.7308 -683.6954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#EBE8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDF3F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000027566742120841696770000017689422805847390624_)"
    },
    d: "M29.4,56.5l18.1,18.1 c3.8,3.8,10.1,3.8,14,0l0,0c3.8-3.8,3.8-10.1,0-14L43.3,42.5c-3.8-3.8-10.1-3.8-14,0l0,0C25.5,46.4,25.5,52.7,29.4,56.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058585638998613416900000009805484387928762247_",
    gradientUnits: "userSpaceOnUse",
    x1: -2602.1648,
    y1: 1795.364,
    x2: -2525.3638,
    y2: 1795.364,
    gradientTransform: "matrix(-0.4174 0.4174 -0.7071 -0.7071 244.7308 2379.9783)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#EBE8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDF3F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000058585638998613416900000009805484387928762247_)"
    },
    d: "M29.4,42.3l18.1-18.1 c3.8-3.8,10.1-3.8,14,0l0,0c3.8,3.8,3.8,10.1,0,14L43.3,56.3c-3.8,3.8-10.1,3.8-14,0l0,0C25.5,52.5,25.5,46.2,29.4,42.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage5Play);
export default __webpack_public_path__ + "static/media/Stage5-Play.adfaa7600b8cdbe0f6df06ce149c7773.svg";
export { ForwardRef as ReactComponent };